// @ts-nocheck
import { isValidElement, ReactNode } from "react";

const getReactNodeText = (node: ReactNode): string => {
    if (typeof node === "string" || typeof node === "number") {
        return String(node);
    }

    if (Array.isArray(node)) {
        return node.map(getReactNodeText).join("");
    }

    if (isValidElement<{ children?: ReactNode }>(node)) {
        return getReactNodeText(node.props.children);
    }

    return "";
};

export default getReactNodeText;
